import React from "react";
import { Alert } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const PolizasVigentesSection = ({
    polizasVigentes,
    loading = false,
    error = ""
}) => {

    return (
        <>
            <br></br>
            <h3 className="compromiso-section-subtitle">
                Pólizas vigentes con AIG
            </h3>
            {error && (
                <Alert color="danger" className="mb-3">
                    {error}
                </Alert>
            )}


            <div className="linea-negocio-tabla-wrapper">

                <DataTable
                    value={polizasVigentes}
                    loading={loading}
                    className="linea-negocio-tabla"
                    responsiveLayout="scroll"
                    emptyMessage={
                        loading
                            ? "Consultando pólizas..."
                            : error
                                ? "No se pudieron consultar las pólizas."
                                : "No se encontraron pólizas vigentes para los ramos seleccionados."
                    }
                >

                    <Column
                        field="ramo"
                        header="RAMO"
                    />

                    <Column
                        field="poliza"
                        header="POLIZA"
                    />

                    <Column
                        field="sucursal"
                        header="SUCURSAL"
                    />

                    <Column
                        field="fechaFin"
                        header="FECHA DE FIN VIGENCIA"
                    />

                </DataTable>

            </div>
        </>
    );
};

export default PolizasVigentesSection;